module.exports = __webpack_public_path__ + "static/media/icon-aluguel-reduza.d15a2ec9.webp";